import { Box, Grid, Link, Typography, useTheme } from '@mui/material'
import React from 'react'
import { routes } from '../../router/routes'
import { BigPaper } from '../BigPaper/BigPaper'
import { PrimaryButton } from '../PrimaryButton'
import { Success } from '../RegisterBrandForm/Success'
import { AccountDetails } from './AccountDetails'
import { AddressFields } from './AddressFields'
import { BasicInfoFields } from './BasicInfoFields'
import { InfluencerForm } from './InfluencerForm'
import { Social } from './Social'
import { Verticals } from './Verticals'

export const RegisterFormFields = ({ isLoading, isSuccess }) => {
  const theme = useTheme()

  if (isSuccess) {
    return <Success />
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BigPaper
          elevation={0}
          style={{
            backgroundColor: theme.palette.sunrise6.main,
            padding: '40px 32px'
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography
                variant='h5'
                style={{
                  color: '#fff',
                  fontWeight: '800',
                  fontSize: '36px'
                }}
                align='center'
              >
                Welcome to the BlogaFam!
              </Typography>
              <Typography
                variant='caption'
                component='div'
                sx={{
                  fontSize: '.9rem',
                  color: 'rgba(255,255,255,.9)',
                  textAlign: 'center',
                  width: '100%'
                }}
              >
                Get dibs on the best campaigns and ELEVATE your career to the
                next level!
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <BasicInfoFields />
            </Grid>
            <Grid item xs={12}>
              <AddressFields />
            </Grid>
            <Grid item xs={12}>
              <Verticals />
            </Grid>
            <Grid item xs={12}>
              <Social />
            </Grid>
            <Grid item xs={12}>
              <AccountDetails />
            </Grid>
          </Grid>
        </BigPaper>
      </Grid>
      <Grid item xs={12}>
        <Box paddingRight={3} display='flex' justifyContent='flex-end'>
          <PrimaryButton type='submit' disabled={isLoading}>
            Submit
          </PrimaryButton>
        </Box>
      </Grid>
      <Grid item xs={12} container spacing={2} justifyContent='center'>
        <Grid item>
          <Link
            href={routes.privacyPolicy}
            sx={{
              color: '#FFF',
              opacity: 0.7,
              textDecoration: 'none',
              ':hover': { opacity: 1 }
            }}
          >
            <Typography variant='caption'>Privacy Policy</Typography>
          </Link>
        </Grid>
        <Grid item>
          <Link
            href={routes.terms}
            sx={{
              color: '#FFF',
              opacity: 0.7,
              textDecoration: 'none',
              ':hover': { opacity: 1 }
            }}
          >
            <Typography variant='caption'>Terms and Condition</Typography>
          </Link>
        </Grid>
      </Grid>
    </Grid>
  )
}

export const RegisterInfluencerForm = () => {
  return (
    <InfluencerForm>
      <RegisterFormFields />
    </InfluencerForm>
  )
}
